import React from 'react';
import _ from 'lodash';

import './styles.css';
const TOOLTIP_NAME = 'roomTypeTooltip';
import CheckBox from 'components/CheckBox';

const PurposeTimelineGroup = ({group, selectRoom, selectedRoomsIds}) => {
  return (
    <div className="PurposeTimelineGroup colab-row-space-between">
      <CheckBox
        name={group.roomId}
        className="PurposeTimelineGroup__checkbox"
        label=""
        value={_.includes(selectedRoomsIds, group.roomId)}
        onChange={event => {
          selectRoom(event.target.checked, group.roomId);
        }}
      />
      <div className="PurposeTimelineGroup__title colab-clickable colab-bold ">
        {group.title}
      </div>
      <div
        className="PurposeTimelineGroup__type"
        data-tip={group.rightTitle}
        data-for={TOOLTIP_NAME}>
        {group.rightTitle}
      </div>
    </div>
  );
};

export default PurposeTimelineGroup;
